import {Component, Input} from '@angular/core';
import {IoniconsOutline} from '@pt/pt-models';

@Component({
  selector: 'pt-application-name-cell-renderer',
  template: `
    <div class='pt-application-name-cell-renderer'>
      <div class='d-flex flex-row align-items-center'>
<!--        <pt-icon [key]='IconWarning'-->
<!--                 *ngIf='appAssessmentUnsupported'-->
<!--                 class='text-warning' container='body'-->
<!--                 ngbTooltip="{{'TOOLTIP.UNAVAILABLE_ASSESSMENT_CAT' | translate}}"-->
<!--        ></pt-icon>-->
        <img src='assets/images/icon-svg/applications.svg'>
      </div>
      <span>{{label}}</span>
    </div>
  `,
  styles: [`
    .pt-application-name-cell-renderer {
      display: flex;
      align-items: center;
    }

    img {
      position: relative;
      height: 20px;
      width: 20px;
      margin-right: 8px;
    }

    span {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  `]
})
export class ApplicationNameCellRendererComponent {
  // @Input() appAssessmentUnsupported: boolean;
  @Input() label: string;

  public IconWarning = IoniconsOutline.warning;
}
